export default __webpack_public_path__ + "static/media/105.56352c8f.jpg";